import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import Navbar from "./Navbar";
import Research from "./Research";
import Contact from "./Contact";
import AllPrograms from "./AllPrograms";
import OutreachFunding from "./OutreachFunding";
import ProgramsBrowse from "./ProgramsBrowse";
import MTechAdditiveManufacturing from "./MTechAdditiveManufacturing";
import GenericProgram from "./programs/GenericProgram";
import ProgramsLanding from "./ProgramsLanding";
import Staff from "./components/people/Staff";
import PhDStudents from "./components/people/PhDStudents";
import PGStudents from "./components/people/PGStudents";
import Alumni from "./components/people/Alumni";
import Forms from "./Forms";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Navbar />}>
      <Route index element={<App />} />
      <Route path="/contactus" element={<Contact />} />
      <Route path="/research" element={<Research />} />
      <Route path="/outreach-funding" element={<OutreachFunding />} />
      <Route path="/programs" element={<AllPrograms />}>
        {/* Landing page — card grid of all programs */}
        <Route index element={<ProgramsLanding />} />
        {/* Individual program routes */}
        <Route path=":programId" element={<GenericProgram />} />
        <Route path=":programId/:section" element={<GenericProgram />} />
      </Route>
      <Route path="/people" element={<Navigate to="/people/staff" replace />} />
      <Route path="/people/staff" element={<Staff />} />
      <Route path="/people/phd-students" element={<PhDStudents />} />
      <Route path="/people/pg-students" element={<PGStudents />} />
      <Route path="/people/alumni" element={<Alumni />} />
      <Route path="/forms" element={<Forms />} />
      <Route
        path="/mtech/additive-manufacturing"
        element={<MTechAdditiveManufacturing />}
      />
      {/* Catch-all route for 404 */}
      <Route
        path="*"
        element={
          <div style={{ padding: "2rem", textAlign: "center" }}>
            <h1 style={{ fontSize: "2rem", marginBottom: "1rem" }}>404 - Page Not Found</h1>
            <p style={{ fontSize: "1.1rem", color: "#666" }}>
              The page you're looking for doesn't exist.
            </p>
            <a
              href="/"
              style={{
                display: "inline-block",
                marginTop: "1.5rem",
                padding: "0.75rem 1.5rem",
                background: "#2d5d6d",
                color: "white",
                textDecoration: "none",
                borderRadius: "6px",
              }}
            >
              Go Home
            </a>
          </div>
        }
      />
    </Route>,
  ),
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RouterProvider router={router} />);
